import React from 'react';
import { ChevronRight } from 'lucide-react';

const AppSettings = () => {

  return (
    <div className="flex h-screen bg-white text-gray-800">
      <div className="flex-1 flex flex-col">
        {/* Breadcrumb */}
        <div className="border-b border-gray-200 p-4 flex items-center gap-2 text-sm">
          <span className="text-gray-500">Dashboard</span>
          <ChevronRight size={14} className="text-gray-400" />
          <span className="text-gray-500">Settings</span>
          <ChevronRight size={14} className="text-gray-400" />
          <span>App Settings</span>
        </div>

        {/* Content */}
        <div className="p-6 flex-1">
          <div className="mb-6">
            <h1 className="text-2xl font-semibold mb-2">App Settings</h1>
            <p className="text-gray-500">Manage Your Application Settings from Here</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppSettings;